import React from 'react'
import { Route } from 'react-router-dom'
import EmailUpdateSuccess from './EmailUpdateSuccess';

import { emailUpdateSuccess } from "../../../constants/routePaths"

const EmailUpdateSuccessRoute = [
  <Route
    key="EmailUpdateSuccess"
    exact path={emailUpdateSuccess}
    component={EmailUpdateSuccess}
  />,
];

export default EmailUpdateSuccessRoute